import React, { useEffect } from 'react'
import AwesomeSlider from 'react-awesome-slider'
import withAutoplay from 'react-awesome-slider/dist/autoplay'
import { Container } from '@cleartrip/ct-design-components'
import Image from 'next/image'

import styles from './_carousel.module.scss'

import { IBanner } from '@/types/home'
import CarouselRightCheveron from '@/assets/icons/CarouselRightCheveron'
import CarouselLeftCheveron from '@/assets/icons/CarouselLeftCheveron'
import { useAppDispatch } from '@/redux/store/hooks'
import { setLineageId } from '@/redux/slices/lineageId'
import { ravenSDKHomeTrigger } from '@/analytics/raven/ravenSDKHelper'
const transitionInterval = 5000 //in milliseconds

const CarousalOffer = (props: { enabled?: boolean; banners?: IBanner[] }) => {
    const dispatch = useAppDispatch()
    const { banners = [], enabled } = props || {}

    useEffect(() => {
        let custom = 2
        if (banners?.length) {
            custom = banners.length
        }
        document.documentElement.style.setProperty('--arrow-value', `${(170 - ((custom - 1) * 11 + 17)) / 2}px`)
    }, [banners])

    const AutoplaySlider = withAutoplay(AwesomeSlider)

    const showCarouselButtons = banners.length > 1

    const onBannerClick = (banner: IBanner, index: number) => {
        dispatch(setLineageId())
            const payload = {
            action_name: 'merch_click',
            object_id: 'topright_carouselbanner',
            url: banner?.url ? `www.cleartrip.com${banner?.url}` : 'n/a',
            src: banner?.src || 'n/a'
            
        }
        ravenSDKHomeTrigger('a_merch_widget_click', payload)
    }

    const onSlideChange = (slideData: any) => {
        const currentSlideIndex = slideData?.currentIndex || 0
        if (banners?.length) {
            const payload = {
                action_name: 'merch_view',
                object_id: 'topright_carouselbanner',
                url: banners[currentSlideIndex]?.url ? `www.cleartrip.com${banners[currentSlideIndex]?.url}` : 'n/a',
                src: banners[currentSlideIndex]?.src || 'n/a'
            }
            ravenSDKHomeTrigger('a_merch_widget_view', payload)
        }
    }
    useEffect(() => {
        if (enabled && banners?.length) {
            banners.forEach((banner, index) => {
                const payload = {
                    action_name: 'merch_impression',
                    src: banner?.src || 'n/a',
                    object_id: 'topright_carouselbanner',
                    url: banner?.url ? `www.cleartrip.com${banner?.url}` : 'n/a'   
                }
                ravenSDKHomeTrigger('a_merch_widget_impression', payload)
            })
            ravenSDKHomeTrigger('a_merch_widget_view', {
                action_name: 'merch_view',
                object_id: 'topright_carouselbanner',
                url: banners[0]?.url ? `www.cleartrip.com${banners[0]?.url}` : 'n/a',
                src: banners[0]?.src || 'n/a'
            })
            }
    }, [])

    return (
        <>
            {enabled && banners?.length ? (
                <>
                    <Container className="bc-neutral-100 br-8 mt-4 o-hidden carousalImg">
                        <AutoplaySlider
                            play={showCarouselButtons}
                            cancelOnInteraction={false}
                            interval={transitionInterval}
                            bullets={showCarouselButtons}
                            buttonContentLeft={showCarouselButtons && <CarouselLeftCheveron />}
                            buttonContentRight={showCarouselButtons && <CarouselRightCheveron />}
                            organicArrows={false}
                            onTransitionEnd={onSlideChange}
                        >
                            {banners.map((item, idx) => (
                                <Container className="br-4" key={idx} onClick={() => onBannerClick(item, idx)}>
                                    <a href={item.url} target="_blank">
                                        {/* TODO: check fastui url config for urls */}
                                        <Image src={item.src} alt={'img'} width={307} height={204} loading='eager' />
                                    </a>
                                </Container>
                            ))}
                        </AutoplaySlider>
                    </Container>
                </>
            ) : (
                <></>
            )}
        </>
    )
}

export default CarousalOffer
